import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

export const getAlertEntityInfoFromContext = (alert) => {
  switch (alert.context) {
    case 2:
      return {
        icon: entityIcon.report(12),
        color: entityColor.report,
      };
    case 3:
      return {
        icon: entityIcon.contest(12),
        color: entityColor.contest,
      };
    case 4:
    case 5:
      return {
        icon: entityIcon.effort(12),
        color: entityColor.effort,
      };
    default:
      return {
        icon: entityIcon.alert(12),
        color: entityColor.alert,
      };
  }
};

export const getAlerts = () => {
  return [
    {
      id: 1,
      message: "New campaign created",
      description:
        "A new marketing campaign has been successfully created and is ready for review",
      type: "info",
      read: true,
      date: "2024-01-15T10:30:00Z",
      entity: "campaign",
      link_info: {
        path: `/campaigns/${1}`,
        button_text: "View",
      },
    },
    {
      id: 2,
      message:
        "Contest deadline approaching what happens when there is a long message",
      description:
        "The current contest will end in 24 hours. Please review and finalize entries",
      type: "warning",
      read: true,
      date: "2024-01-14T15:45:00Z",
      entity: "contest",
      link_info: {
        path: `/contests/${2}`,
        button_text: "View",
      },
    },
    {
      id: 3,
      message: "New location added",
      description:
        "Planned maintenance window scheduled for this weekend to improve performance",
      type: "info",
      read: false,
      date: "2024-01-13T09:20:00Z",
      entity: "location",
      link_info: {
        path: `/locations/${3}`,
        button_text: "View",
      },
    },
    {
      id: 4,
      message: "User needs help",
      description:
        "A user has requested help with their account. Please review the request",
      type: "info",
      read: false,
      date: "2024-01-15T08:15:00Z",
      entity: "user",
      link_info: {
        path: `/users/${4}`,
        button_text: "View",
      },
    },
    {
      id: 5,
      message: "Payment processing failed",
      description:
        "A payment transaction failed due to insufficient funds. Please review the account",
      type: "error",
      read: false,
      date: "2024-01-15T06:30:00Z",
    },
    {
      id: 6,
      message: "Organization deactivated",
      description:
        "The organization has been deactivated. Please contact support if you need to reactivate it.",
      type: "info",
      read: true,
      date: "2024-01-14T23:00:00Z",
      entity: "organization",
      link_info: {
        path: `/organizations/${6}`,
        button_text: "View",
      },
    },
    {
      id: 7,
      message: "API rate limit exceeded",
      description:
        "API usage has exceeded the rate limit. Consider upgrading the plan",
      type: "warning",
      read: false,
      entity: "contest",
      date: "2024-01-14T14:20:00Z",
    },
    {
      id: 8,
      message: "Email campaign sent successfully",
      description:
        "The email campaign has been delivered to all subscribers without errors",
      type: "success",
      read: false,
      entity: "contest",
      date: "2024-01-15T09:45:00Z",
    },
    {
      id: 9,
      message: "Server performance alert",
      description:
        "Server CPU usage has reached 85%. Consider scaling resources",
      type: "warning",
      read: false,
      entity: "contest",
      date: "2024-01-15T07:10:00Z",
    },
    {
      id: 10,
      message: "New feature deployment completed",
      description:
        "The new analytics dashboard feature has been deployed to production",
      type: "success",
      read: false,
      entity: "contest",
      date: "2024-01-14T16:30:00Z",
    },
    {
      id: 11,
      message: "Security scan detected vulnerabilities",
      description:
        "Security scan found 3 medium-level vulnerabilities that need attention",
      type: "error",
      read: false,
      entity: "contest",
      date: "2024-01-14T11:45:00Z",
    },
    {
      id: 12,
      message: "User feedback received",
      description:
        "New user feedback has been submitted and is awaiting review",
      type: "info",
      read: false,
      date: "2024-01-15T08:30:00Z",
    },
    {
      id: 13,
      message: "Backup verification failed",
      description:
        "The backup verification process failed. Manual intervention required",
      type: "error",
      read: false,
      date: "2024-01-14T22:15:00Z",
    },
    {
      id: 14,
      message: "Scheduled task completed",
      description:
        "The daily data synchronization task has completed successfully",
      type: "info",
      read: false,
      date: "2024-01-15T06:00:00Z",
    },
    {
      id: 15,
      message: "Memory usage high",
      description:
        "Application memory usage is at 90%. Consider restarting services",
      type: "warning",
      read: false,
      entity: "contest",
      date: "2024-01-15T05:20:00Z",
    },
    {
      id: 16,
      message: "New integration added",
      description:
        "A new third-party integration has been successfully configured",
      type: "success",
      read: false,
      date: "2024-01-14T13:10:00Z",
    },
    {
      id: 17,
      message: "SSL certificate expiring soon",
      description:
        "SSL certificate will expire in 30 days. Please renew before expiration",
      type: "warning",
      read: false,
      date: "2024-01-13T10:30:00Z",
      entity: "location",
    },
    {
      id: 18,
      message: "Data export completed",
      description:
        "The requested data export has been completed and is ready for download",
      type: "success",
      read: false,
      date: "2024-01-14T17:45:00Z",
    },
  ].map((m) => ({
    ...m,
  }));
};
